import React from "react";
import { Helmet } from "react-helmet-async";
function JobPostComponent({ jobDetails, currentJobUrl, ...props }) {
  // Google Jobs Dynamic Metadata Inmplementation - Start
  // Dynamic meta tags and JSON-LD (structured data)
  const metaTitle = `Job: ${jobDetails?.jobs_title} | Staffing Connect UK`;
  const stripHtml = (html) => html?.replace(/<[^>]+>/g, "") || "";
  const metaDescription = `${jobDetails?.jobs_title} at Staffing Connect in ${jobDetails?.jobs_location_town} | ${stripHtml(jobDetails?.jobs_description).substring(0, 160)}`;
  // const metaDescription = `${jobDetails?.jobs_title} at ${'Staffing Connect'} in ${jobDetails?.jobs_location_town} | ${jobDetails?.jobs_description}`;
  // const metaKeywords = `jobs at staffing connect uk, ${jobDetails?.jobs_title} jobs, ${jobDetails?.jobs_location_town} jobs, recruitment, hiring, apply now`;

  // JSON-LD for Google for Jobs (official schema)
  const jobPostingSchema = {
    "@context": "https://schema.org/",
    "@type": "JobPosting",
    url: currentJobUrl,
    // site: "https://staffingconnect.co.uk",
    title: jobDetails?.jobs_title,
    description:
      (stripHtml(jobDetails?.jobs_description) || "").trim() ||
      `Job opportunity at Staffing Connect for ${jobDetails?.jobs_title}.`,
    identifier: {
      "@type": "PropertyValue",
      name: `${jobDetails?.jobs_title || "Jobs"} at Staffing Connect`,
      value: jobDetails?.jobs_access_token,
    },
    datePosted: new Date(jobDetails?.datePosted).toISOString().split("T")[0],
    validThrough: new Date(jobDetails?.jobs_end_date)
      .toISOString()
      .split("T")[0],
    employmentType:
      jobDetails?.jobs_job_type_contract_type === "permanentrequirement"
        ? "FULL_TIME"
        : jobDetails?.jobs_job_type_contract_type === "temporaryrequirement"
          ? "TEMPORARY"
          : jobDetails?.jobs_job_type_contract_type === "temporaryandpermanent"
            ? "OTHER"
            : "OTHER", // e.g. "FULL_TIME"
    hiringOrganization: {
      "@type": "Organization",
      name: "Staffing Connect",
      sameAs: "https://staffingconnect.co.uk",
      logo: "https://staffingconnect.co.uk/logo.png",
      description: "Staffing Connect UK is a trusted recruitment agency specializing in care and education roles across the UK.",      
    },
    jobLocation: {
      "@type": "Place",
      address: {
        "@type": "PostalAddress",
        streetAddress: jobDetails?.jobs_location_address_1 || "",
        addressLocality: jobDetails?.jobs_location_town,
        addressRegion:
          jobDetails?.jobs_location_region || jobDetails?.jobs_location_town,
        postalCode: jobDetails?.jobs_location_post_code,
        addressCountry: "GB",
      },
    },
    baseSalary: {
      "@type": "MonetaryAmount",
      currency: "GBP",
      value: {
        "@type": "QuantitativeValue",
        value: jobDetails?.jobs_salary_details_min_salary || "",
        unitText:
          jobDetails?.jobs_salary_details_salary_type === "per_hour"
            ? "HOUR"
            : jobDetails?.jobs_salary_details_salary_type === "per_day"
              ? "DAY"
              : jobDetails?.jobs_salary_details_salary_type === "per_annum"
                ? "YEAR"
                : "MONTH",
      },
      //   application: currentJobUrl,
    },
    // directApply: true,
    // Optionally: add fields for remote jobs, benefits, qualifications etc.
  };

  // Google Jobs Dynamic Metadata Inmplementation - End

  return (
    <>
      {/* SEO Google Jobs - Start */}
      {jobDetails?.jobs_title && (
        <>
          <div>
            <Helmet>
              {/* <title>{metaTitle}</title>
              <meta name="description" content={metaDescription} />
              // <meta name="keywords" content={metaKeywords} /> */}
              <meta property="og:title" content={metaTitle} />
              <meta property="og:description" content={metaDescription} />
              <meta property="og:url" content={currentJobUrl} />
              <meta
                property="og:image"
                content={
                  "https://staffingconnect.co.uk/logo.png" || "/logo.png"
                }
              />
              <meta name="robots" content="index, follow" />
              {/* JSON-LD Schema for Google for Jobs */}
              <script type="application/ld+json">
                {JSON.stringify(jobPostingSchema)}
              </script>
            </Helmet>
            <h1 style={{ display: "none" }}>{jobDetails?.jobs_title}</h1>
            {/* <h2 style={{ display: "none" }}>
              {"Staffing Connect"} - {jobDetails?.jobs_title}
            </h2> */}
            <p style={{ display: "none" }}>{jobDetails?.jobs_description}</p>
          </div>
        </>
      )}
      {/* SEO Google Jobs - End */}
    </>
  );
}

export default JobPostComponent;
